// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"37ae0af2","72":"d3330773","477":"13911c18","627":"d117c700","663":"e25dfbe3","667":"6194d927","777":"c789e99c","803":"8901be81","820":"e15331ef"}[chunkId] + ".chunk.js";
};